<template>
  <div class="cover" >
    <a-icon type="menu" class="menu-icon" @click="open" />
    <a-breadcrumb>
       <span slot="separator" style="font-size:1.3rem">/</span>
      <a-breadcrumb-item v-for="item in routeList()" :key="item"><span style="font-size:1.3rem" >{{item.toUpperCase()}}</span></a-breadcrumb-item>
    </a-breadcrumb>
    <a-drawer
      height="min-content"
      placement="top"
      :closable="false"
      :visible="visible"
      @close="onClose"
    >
      <sider/>
    </a-drawer>
  </div>

</template>

<script>
import sider from './sider.vue';
export default {
  components: { sider },
  data() {
    return {
      visible:false
    }
  },
  methods: {
    routeList(){

      return this.$route.fullPath.split("/");
    },
    open(){
      this.visible=true
    },
    onClose(){
      this.visible=false
    }
  }
};
</script>

<style scoped>
.cover {
    width: 100%;
    height: inherit;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}
.menu-icon {
  display: none;
}
@media (max-width:700px) {
  .menu-icon {
    display: block;
  }
}
</style>
